module.exports = __webpack_public_path__ + "img/category-skill-game1.69a6f764.png";